import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./style.css";
import tailpieces from "tailpieces";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCaretSquareLeft,
  faCaretSquareRight,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faClock,
  faCog,
  faEye,
  faEyeSlash,
  faEraser,
  faExclamationTriangle,
  faFilter,
  faList,
  faSearch,
  faSignInAlt,
  faSyncAlt,
  faEnvelope,
  faTrash,
  faWrench,
  faPen,
  faHandPointer,
  faThumbsUp,
  faThumbsDown,
  faLink,
  faWindowClose,
  faPaperclip,
  faCamera,
  faFile,
  faArrowUp,
  faArrowDown,
  faCalendar,
  faSignOutAlt,
  faArrowRight,
  faArrowLeft,
  faUsers,
  faPlus,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
  faCaretSquareLeft as any,
  faCaretSquareRight as any,
  faCog as any,
  faEye as any,
  faEyeSlash as any,
  faEraser as any,
  faExclamationTriangle as any,
  faFilter as any,
  faList as any,
  faSearch as any,
  faSignInAlt as any,
  faSyncAlt as any,
  faClock as any,
  faCheck as any,
  faChevronDown as any,
  faChevronLeft as any,
  faChevronRight as any,
  faEnvelope as any,
  faTrash as any,
  faWrench as any,
  faPen as any,
  faHandPointer as any,
  faThumbsUp as any,
  faThumbsDown as any,
  faLink as any,
  faWindowClose as any,
  faPaperclip as any,
  faCamera as any,
  faFile as any,
  faArrowUp as any,
  faArrowDown as any,
  faCalendar as any,
  faSignOutAlt as any,
  faArrowRight as any,
  faArrowLeft as any,
  faUsers as any,
  faPlus as any,
  faSave as any,
);

const app = createApp(App);

app.component("font-awesome-icon", FontAwesomeIcon);

app.use(store).use(router).use(tailpieces)

app.mount('#app')
